import { Camera, NotebookPen } from 'lucide-react'

export const coachingOperationAppearance = {
  reviewNote: {
    Icon: NotebookPen,
    surface: 'bg-coaching-review-surface',
    border: 'border-coaching-review-border',
    iconBackground: 'bg-coaching-review',
    iconText: 'text-coaching-review',
  },
  lessonPhoto: {
    Icon: Camera,
    surface: 'bg-coaching-photo-surface',
    border: 'border-coaching-photo-border',
    iconBackground: 'bg-coaching-photo',
    iconText: 'text-coaching-photo',
  },
} as const

export type CoachingOperationKind = keyof typeof coachingOperationAppearance
